import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Container, Box, Typography, TextField, Button, InputAdornment, IconButton, FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import PlumSvg from "../component/PlumSvg";
import { merchantAPI } from "../../Api";

const AddClient = () => {
  const [name, setName] = useState("");
  const [site, setSite] = useState("");
  const [secret, setSecret] = useState("");
  const [category, setCategory] = useState("main");
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    name: "",
    site: "",
  });

  const AlertSuccess = () => (
    <Alert severity="success">
      Мерчант создан!
    </Alert>
  );

  const AlertError = () => (
    <Alert severity="error">
      Ошибка создания мерчанта
    </Alert>
  );

  

  const validateForm = () => {
    const newErrors = {};

    if (!name) newErrors.name = "Название обязательно";
    if (!site) newErrors.site = "Ссылка обязательна";
    if (!secret) newErrors.secret = "Секрет обязательно";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {

        let data = await merchantAPI.createMerchant({name,site,secret,category});
        if (data.data.success) {
          setName("");
          setSite("");
          setAlert(<AlertSuccess />);
          navigate('/merchants/list');
        } else {
          setAlert(<AlertError />);
        }
      } catch (e) {
        setAlert(<AlertError />);
      }
    }
  };

  return (
    <Container maxWidth="sx">
      <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2, bgcolor: "#fefcfb" }}>
        <Typography variant="h5" align="center" gutterBottom>
          <PlumSvg /> Добавить мерчанта
        </Typography>
        
        {alert && <div>{alert}</div>} {/* Условный рендеринг Alert */}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Название"
            variant="outlined"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.name)}
            helperText={errors.name}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />

          <FormControl fullWidth margin="normal">
            <InputLabel id="merchant-category-label">Категория</InputLabel>
            <Select
              labelId="merchant-category-label"
              value={category}
              label="Категория"
              onChange={(e) => setCategory(e.target.value)}
            >
              <MenuItem value="main">Основные</MenuItem>
              <MenuItem value="external">Сторонние</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Сайт https://"
            variant="outlined"
            fullWidth
            margin="normal"
            value={site}
            onChange={(e) => setSite(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.site)}
            helperText={errors.site}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />

          <TextField
            label="Пароль"
            variant="outlined"
            fullWidth
            margin="normal"
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.secret)}
            helperText={errors.secret}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, backgroundColor: "#683d62" }}
          >
            Добавить мерчанта
          </Button>
        </form>
      </Box>
    </Container>
  );
};


export default AddClient;
